(function () {
  'use strict';

  var SETTINGS = (window.minQtySettings = window.minQtySettings || {});
  var MESSAGE_TEMPLATE =
    SETTINGS.belowMinMessage || 'Please add [count] more item(s) to continue to checkout.';

  function parseMin(raw) {
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 1) return 1;
    return n;
  }

  function getMin(input) {
    if (!input) return 1;
    return parseMin(input.getAttribute('data-min-qty'));
  }

  function clampInput(input) {
    if (!input) return false;
    var min = getMin(input);
    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < min) {
      input.value = min;
      return true;
    }
    return false;
  }

  function guardQuantityInput(input) {
    if (!input || input.dataset.minQtyGuarded === 'true') return;
    if (input.getAttribute('name') !== 'quantity') return;
    var min = getMin(input);
    if (min <= 1 && !input.hasAttribute('data-min-qty')) return;
    input.dataset.minQtyGuarded = 'true';

    function updateMinusState() {
      var current = parseInt(input.value, 10);
      var disabled = isNaN(current) || current <= min;
      toggleMinusDisabled(input, disabled);
    }

    var wrapper = input.closest('quantity-input');
    if (wrapper) {
      var minusBtn = wrapper.querySelector("button[name='minus']");
      if (minusBtn) {
        minusBtn.addEventListener(
          'click',
          function (event) {
            var current = parseInt(input.value, 10);
            if (isNaN(current) || current <= min) {
              event.preventDefault();
              event.stopImmediatePropagation();
              if (input.value != min) {
                input.value = min;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            updateMinusState();
          },
          true
        );
        var plusBtn = wrapper.querySelector("button[name='plus']");
        if (plusBtn) {
          plusBtn.addEventListener('click', function () {
            setTimeout(updateMinusState, 0);
          });
        }
      }
    }

    input.addEventListener('input', updateMinusState);
    input.addEventListener('blur', function () {
      clampInput(input);
      updateMinusState();
    });
    input.addEventListener('change', function () {
      clampInput(input);
      updateMinusState();
    });

    clampInput(input);
    updateMinusState();
  }

  function toggleMinusDisabled(input, disabled) {
    var wrapper = input.closest('quantity-input');
    if (!wrapper) return;
    var minusBtn = wrapper.querySelector("button[name='minus']");
    if (minusBtn) {
      minusBtn.classList.toggle('disabled', !!disabled);
      minusBtn.classList.toggle('min-qty-minus-blocked', !!disabled);
    }
  }

  function guardCartQuantityInput(input) {
    if (!input || input.dataset.minQtyCartGuarded === 'true') return;
    var min = getMin(input);
    if (min <= 1) return;
    input.dataset.minQtyCartGuarded = 'true';

    var loaded = parseInt(input.value, 10);
    if (isNaN(loaded)) loaded = min;
    var floor = Math.min(min, loaded);

    var minusBtn = null;
    var wrapper = input.closest('quantity-input');
    if (wrapper) {
      minusBtn = wrapper.querySelector("button[name='minus']");
      if (minusBtn) {
        minusBtn.addEventListener(
          'click',
          function (event) {
            var current = parseInt(input.value, 10);
            if (isNaN(current)) current = floor;
            var step = parseInt(input.step, 10) || 1;
            if (current <= floor) {
              event.preventDefault();
              event.stopImmediatePropagation();
            } else if (current - step < floor) {
              event.preventDefault();
              event.stopImmediatePropagation();
              input.value = floor;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              updateMinusState();
            }
          },
          true
        );
      }
    }

    function updateMinusState() {
      if (!minusBtn) return;
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = floor;
      minusBtn.classList.toggle('min-qty-minus-blocked', current <= floor);
    }

    input.addEventListener('input', updateMinusState);
    input.addEventListener('change', function () {
      var current = parseInt(input.value, 10);
      if (isNaN(current) || current < floor) {
        input.value = floor;
      }
      updateMinusState();
    });
    input.addEventListener('blur', function () {
      var current = parseInt(input.value, 10);
      if (isNaN(current) || current < floor) {
        input.value = floor;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateMinusState();
    });

    updateMinusState();
  }

  function guardAll(root) {
    var scope = root || document;
    scope
      .querySelectorAll('.quantity__input[data-min-qty][name="quantity"]')
      .forEach(guardQuantityInput);
    scope
      .querySelectorAll('.quantity__input[data-min-qty][name="updates[]"]')
      .forEach(guardCartQuantityInput);
  }

  function guardProductForms() {
    document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach(function (form) {
      if (form.dataset.minQtyGuarded === 'true') return;
      form.dataset.minQtyGuarded = 'true';
      form.addEventListener(
        'submit',
        function (event) {
          var qtyInput =
            form.querySelector('[name="quantity"]') ||
            document.querySelector('.quantity__input[name="quantity"][form="' + form.id + '"]') ||
            document.querySelector('[name="quantity"][form="' + form.id + '"]');
          if (!qtyInput) return;
          var min = getMin(qtyInput);
          var current = parseInt(qtyInput.value, 10);
          if (isNaN(current) || current < min) {
            event.preventDefault();
            event.stopImmediatePropagation();
            qtyInput.value = min;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            qtyInput.focus();
          }
        },
        true
      );
    });
  }

  function guardProductCards() {
    document.querySelectorAll('.product-card-buttons product-form').forEach(function (pf) {
      if (pf.dataset.minQtyCardGuarded === 'true') return;
      pf.dataset.minQtyCardGuarded = 'true';

      var min = parseInt(pf.dataset.minQty, 10);
      if (isNaN(min) || min <= 1) return;

      var url = resolveCardProductUrl(pf);

      var form = pf.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        form.addEventListener(
          'submit',
          function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (url) window.location.href = url;
          },
          true
        );
      }

      var addBtn = pf.querySelector('button[name="add"]');
      if (addBtn) {
        addBtn.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (url) window.location.href = url;
          },
          true
        );
      }
    });
  }

  function resolveCardProductUrl(el) {
    var card = el.closest('.card-wrapper, .card, li, .grid__item') || el.parentNode;
    if (card) {
      var link =
        card.querySelector('a[href*="/products/"].full-unstyled-link') ||
        card.querySelector('a[href*="/products/"]');
      if (link) return link.getAttribute('href');
    }
    var anyLink = el.querySelector('[data-product-url]');
    if (anyLink) return anyLink.getAttribute('data-product-url');
    return null;
  }

  function buildItemMessage(needed) {
    return MESSAGE_TEMPLATE.replace('[count]', needed).replace('X', needed);
  }

  function findItemMessageEl(input) {
    var row = input.closest('tr, .cart-item, li');
    if (!row) return null;
    return row.querySelector('[data-min-qty-item-message]');
  }

  var WARNING_ICON =
    '<svg class="min-qty-message__icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">' +
    '<path d="M10 2.5 1.25 17.5h17.5L10 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
    '<path d="M10 8v3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '<circle cx="10" cy="14.25" r="0.9" fill="currentColor"/></svg>';

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setItemMessage(el, text) {
    if (!el) return;
    var next = text || '';
    if (el.getAttribute('data-msg') !== next) {
      el.setAttribute('data-msg', next);
      el.innerHTML = next
        ? WARNING_ICON + '<span class="min-qty-message__text">' + escapeHtml(next) + '</span>'
        : '';
    }
    var show = !!text;
    if (el.hidden === show) el.hidden = !show;
    el.classList.toggle('min-qty-item-message--active', show);
  }

  function evaluateCartContext(ctx) {
    if (!ctx.form) return;
    var inputs = ctx.form.querySelectorAll('.quantity__input[data-min-qty]');
    var belowCount = 0;

    inputs.forEach(function (input) {
      var min = getMin(input);
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = 0;
      var msgEl = findItemMessageEl(input);
      if (min > 1 && current < min) {
        belowCount++;
        setItemMessage(msgEl, buildItemMessage(min - current));
      } else {
        setItemMessage(msgEl, '');
      }
    });

    if (ctx.checkoutBtn) {
      if (belowCount > 0) {
        ctx.checkoutBtn.setAttribute('disabled', 'disabled');
        ctx.checkoutBtn.setAttribute('aria-disabled', 'true');
        ctx.checkoutBtn.classList.add('min-qty-checkout-blocked');
      } else if (ctx.checkoutBtn.classList.contains('min-qty-checkout-blocked')) {
        ctx.checkoutBtn.removeAttribute('disabled');
        ctx.checkoutBtn.removeAttribute('aria-disabled');
        ctx.checkoutBtn.classList.remove('min-qty-checkout-blocked');
      }
    }

    return belowCount === 0;
  }

  function evaluateCartPage() {
    var form = document.getElementById('cart');
    if (!form) return;
    evaluateCartContext({ form: form, checkoutBtn: document.getElementById('checkout') });
  }

  function evaluateCartDrawer() {
    var form = document.getElementById('CartDrawer-Form');
    if (!form) return;
    evaluateCartContext({ form: form, checkoutBtn: document.getElementById('CartDrawer-Checkout') });
  }

  function evaluateAllCarts() {
    evaluateCartPage();
    evaluateCartDrawer();
  }

  function refresh() {
    guardAll();
    guardProductForms();
    guardProductCards();
    evaluateAllCarts();
  }

  function init() {
    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refresh, 0);
      });
    }
    ['cart:refresh', 'cart:updated', 'cart-drawer:open'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(refresh, 0);
      });
    });

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (m) {
          var t = m.target;
          return !(t && t.closest && t.closest('.min-qty-item-message'));
        });
        if (!relevant || mo._scheduled) return;
        mo._scheduled = true;
        setTimeout(function () {
          mo._scheduled = false;
          refresh();
        }, 50);
      });
      ['cart-drawer', 'cart-items', 'cart-drawer-items'].forEach(function (sel) {
        var node = document.querySelector(sel);
        if (node) mo.observe(node, { childList: true, subtree: true });
      });
    }
  }

  window.MinQty = {
    parseMin: parseMin,
    getMin: getMin,
    clampInput: clampInput,
    evaluateAllCarts: evaluateAllCarts,
    refresh: refresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
